<template>
    <v-container>
        <v-card>
            <v-card-text>
                <h4 class="primary--text">{{$route.params.id?this.$t('lang.common.edit'):this.$t('lang.common.create')}}
                    {{$t('lang.role.title')}}</h4>
                <v-form>
                    <v-text-field type="text" :label="$t('lang.role.roleName')"
                                  v-model="role.roleName"
                                  name="roleName" v-validate="'required|roleNameUnique'"
                                  :data-vv-as="$t('lang.role.roleName')"
                                  maxLength="50" autofocus
                                  :error-messages="errors.first('roleName')"
                    ></v-text-field>

                    <v-text-field type="text" :label="$t('lang.role.roleDescription')" v-model.trim="role.description"
                                  name="description" v-validate="'required'" maxLength="250"
                                  :error-messages="errors.first('description')"
                                  :data-vv-as="$t('lang.role.roleDescription')"
                    ></v-text-field>
                    <div class="basic">
                        <v-label>{{$t('lang.common.active')}}:</v-label>
                        <v-switch :label="role.active ? 'On': 'Off'" v-model="role.active"></v-switch>
                    </div>
                    <div>{{$t('lang.role.permission')}}</div>

                    <v-data-table
                            :headers="headers"
                            :items="childMenus"
                            class="elevation-1"
                            :rows-per-page-items="[100]"
                    >
                        <template v-slot:headers="props">
                            <tr>
                                <th align="left">{{$t("lang.role.menu")}}</th>
                                <th align="left">{{$t("lang.role.accessLevel")}}
                                </th>
                            </tr>
                            <tr class="grey lighten-3">
                                <td><b>{{$t("lang.role.checkAll")}}</b></td>
                                <td>
                                    <div style="margin-top: 15px;">
                                        <v-radio-group @change="onAllAccessLevelChange" v-model="allAccessLevel" row>
                                            <v-radio :label="$t('lang.role.none')" :value="0"></v-radio>
                                            <!--v-radio :label="$t('lang.role.read')" :value="1"></v-radio-->
                                            <v-radio :label="$t('lang.role.read_write')" :value="2"></v-radio>
                                        </v-radio-group>
                                    </div>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:items="props">
                            <td>{{ props.item['name'+selectedLocaleIndex] }}</td>
                            <td>
                                <div style="margin-top: 15px;">
                                    <v-radio-group @change="onChange"
                                                   v-model="permissionList[props.item.menuId].accessLevel" row>
                                        <v-radio :label="$t('lang.role.none')" :value="0"></v-radio>
                                        <!--v-radio :label="$t('lang.role.read')" :value="1"></v-radio-->
                                        <v-radio :label="$t('lang.role.read_write')" :value="2"></v-radio>
                                    </v-radio-group>
                                </div>
                            </td>
                        </template>
                    </v-data-table>

                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" dark @click="handleSubmit">
                    <v-icon dark left>save</v-icon>
                    {{$t('lang.common.save')}}
                </v-btn>
                <v-btn color="error" dark @click="back">
                    <v-icon dark left>cancel</v-icon>
                    {{$t('lang.common.cancel')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
    import {router} from '../../router';
    import {mapState, mapGetters} from 'vuex'
    import {CrudService} from "@/services";
    import {menuService} from "@/services/menu.service"
    import {message} from "@/shared/message";
    import {Validator} from "vee-validate";
    import axios from "axios";


    export default {
        name: "RoleEdit",
        data() {
            return {
                submitted: false,
                role: {},
                rolePermissions: [],
                allAccessLevel: 3,
                headers: [
                    {text: 'Menu', value: 'name'},
                    {text: 'Access Level', value: 'accessLevel'},
                ],
            };
        },
        computed: {
            ...mapState({
                loading: state => state.common.loading,
                //role: state => state.crud.role.item,
                allMenus: state => state.menu.allMenus,
                childMenus: state => {
                    var childItems = state.menu.allMenus.filter(item => {
                        return item.menuType == 2;
                    });
                    return childItems;
                },
                //permission for each menu items, show on the page
                permissionList(state) {
                    //debugger;
                    var objArray = {};
                    var childItems = state.menu.allMenus.filter(item => {
                        return item.menuType == 2;
                    });
                    //loop child menu items and get permission for each
                    childItems.forEach(menuItem => {
                        //get permission for menu item
                        var found = this.rolePermissions.find(function (permissionItem) {
                            return permissionItem.menuId == menuItem.menuId;
                        });
                        if (found) {
                            objArray[menuItem.menuId] = found;
                        } else {
                            //default permission
                            objArray[menuItem.menuId] = {
                                menuId: menuItem.menuId,
                                accessLevel: 0,
                                roleId: this.$route.params.id
                            };
                        }
                    });
                    return objArray;
                },
                permissionArray() {
                    var arr = [];
                    for (var key in this.permissionList) {
                        if (this.permissionList.hasOwnProperty(key)) {
                            arr.push(this.permissionList[key]);
                        }
                    }
                    return arr;
                }
            }),
            ...mapGetters(["selectedLocaleIndex"])
        },
        watch: {
            /*allAccessLevel: function (val) {
              for (var key in this.permissionList) {
                  if (this.permissionList.hasOwnProperty(key)) {
                      this.permissionList[key].accessLevel = val;
                  }
              }
            },*/

        },
        methods: {
            onAllAccessLevelChange(val) {
                for (var key in this.permissionList) {
                    if (this.permissionList.hasOwnProperty(key)) {
                        this.permissionList[key].accessLevel = val;
                    }
                }
            },
            onChange(val) {
                if (val != 2)
                    this.allAccessLevel = 3;
            },
            handleSubmit(e) {
                //console.log('permissionList:', this.permissionList);
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        // ensure product is included before saving
                        const domain = window.location.hostname;
                        const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
                        this.role.product = product;

                        if (this.$route.params.id) {
                            //update role and permission data
                            CrudService.of('role').updateItem(this.role).then(() => {
                                message.success(`Update Role Success!`, '/role/list');
                            });
                            menuService.updatePermissionList(this.permissionArray);
                        } else {
                            console.log("permissionList:", this.permissionList);
                            //create role data first, then update permission with that role
                            CrudService.of('role').createItem(this.role).then((role) => {

                                //add roleid to permission list
                                var permissionListWithRoleId = [];
                                for (var key in this.permissionList) {
                                    if (this.permissionList.hasOwnProperty(key)) {
                                        var permissionItem = this.permissionList[key];
                                        permissionItem.roleId = role.id;
                                        permissionListWithRoleId.push(permissionItem);
                                    }
                                }
                                menuService.updatePermissionList(permissionListWithRoleId).then(() => {
                                    message.success(`Create Role Success!`, '/role/list');
                                });
                            });
                        }
                    }
                });
            },
            back() {
                router.push('/role/list');
            }
        },
        created() {
            if (this.$route.params.id) {
                //let me = this;
                CrudService.of('role').getItem(this.$route.params.id).then(role => {
                    this.role = role;
                    this.initRoleName = role.roleName;
                });
                menuService.getPermissionList(this.$route.params.id).then(data => {
                    this.rolePermissions = data;
                });
                this.$store.dispatch("menu/getAllMenus");
            } else {
                this.role.active = true;
                // default product for new role
                const domain = window.location.hostname;
                const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";
                this.role.product = product;
            }
        },
        mounted() {
            let me = this;
            const domain = window.location.hostname;
            const product = domain.includes("lms-edusmart.") ? "EDUSMART" : "BABILALA";

            const roleNameUnique = (value) => {
                if (me.initRoleName == value) {
                    return true;
                }
                return axios.get(`${process.env.VUE_APP_API_URL}/role/validate-rolename?rolename=${value}&product=${product}`).then((data) => {
                    return {
                        valid: data.valid,
                        data: {
                            message: data.message
                        }
                    };
                });
            };

            Validator.extend("roleNameUnique", {
                validate: roleNameUnique,
                getMessage: (field, params, data) => {
                    return this.$t('lang.role.roleNameExist');
                }
            });

        }
    };
</script>
